module.exports = __webpack_public_path__ + "static/media/dish10.3e7be247.jpg";